import { Store } from "@/stores/common/store.core";
import type { StoreJsonResponse } from "@/stores/common/store.core";
import type { ResponsePayload } from "@laborchart-modules/common/dist/api";
import type { CompanyEntityOptionsResponse } from "@/react/prop-types";
import { EntitiesValues } from "@/react/prop-types";
export abstract class GanttStore extends Store {
   static getGanttCustomFilter(
      groupId: string,
   ): StoreJsonResponse<ResponsePayload<Partial<CompanyEntityOptionsResponse>>> {
      const params =
         EntitiesValues.map((entity, index) => `entities[${index}]=${entity}`).join("&") +
         `&group_id=${groupId}`;
      return this.requestJson({
         url: `/api/v3/company/entity-options?${params}`,
         method: "GET",
      });
   }
}
